import { useAPI } from '@axo/shared/data-access/provider';
import { applicationKeys } from '../../cache-keys/applicationKeys';
import { useQuery } from 'react-query';
import { queryFunction } from '../../query-function';
import { loan_application_api } from '@axo/shared/data-access/api';

export function useApplicationValidation(applicationID: string) {
  const api = useAPI();
  const cacheKey = applicationKeys.validation(applicationID);

  return useQuery(
    cacheKey,
    queryFunction(
      loan_application_api.getApplicationValidationStatus(api),
      ({ queryKey: [, applicationID] }) => applicationID ?? '',
    ),
    {
      enabled: api.token.length > 0 && !!applicationID,
    },
  );
}
